module.exports = __webpack_public_path__ + "img/add-teacher.1bdd0148.png";